export default __webpack_public_path__ + "static/media/BQ-SA.8fb161f0.svg";